export enum ControlType {
  TextBox = 1,
  DateTimePicker = 2,
  Dropdown = 3,
  GroupDropdown = 4,
  RefreshButton = 5,
}
